import { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import { FaMinus, FaPlus } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { Col, Row } from "reactstrap";
import { URL } from "../../api";
import Banner from "../../components/general/Banner";
import Celikler from "../../components/general/Celikler";
import { fetchPageGetSlug } from "../../redux/slices/pageGetSlugSlice";
import { fetchSeoGet } from "../../redux/slices/seoGetSlice";
import ChargingCalculator from './../home/ChargingCalculator';

const Sss = () => {
  const { t } = useTranslation();
  const lang = useSelector((state) => state.lang.lang);
  const seo = useSelector((state) => state.seoGet.data);
  const [loading, setLoading] = useState(false);
  const page = useSelector((state) => state.pageGetSlug.data);
  const [activeIndex, setActiveIndex] = useState(null);
  const dispatch = useDispatch();

  const getData = async () => {
    setLoading(true);
    await dispatch(fetchPageGetSlug({ slug: "sss" }));
    await dispatch(fetchSeoGet({ slug: "sss" }));
    setLoading(false)
  }

  useEffect(() => { getData() }, [])

  useEffect(() => {
    setActiveIndex(0);
    return () => setActiveIndex(null);
  }, []);

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    !loading ? <Celikler>
      {seo && seo.title && seo.description && (
        <Helmet>
          <title>{seo.title?.[lang] || "Çelikler Enerji"}</title>
          <meta name="description" content={seo.description?.[lang] || ""} />
          <meta name="keywords" content={seo.keywords?.[lang] || ""} />
          <meta name="robots" content="index, follow" />
          <link rel="canonical" href={window.location.href} />
        </Helmet>
      )}
      <Banner title={page?.title[lang]} />
      <div className="about-page">
        <div className="textJustifyCenter">
          <div className="f24 d-flex align-items-center justify-content-center mt-5">
            <span className="sss-text color10 fw500 f32">{page?.showcases[0]?.title[lang]}</span>
          </div>
        </div>
        <div className="textJustifyCenter mt-5">
          <div className="mt-5">
            <Row>
              <Col xs={12} sm={6} md={6} lg={6} xl={6}>
                <img src={`${URL}${page?.showcases[0]?.files[0]}`} alt="" className="w-100 sssPageImg" loading="lazy" />
              </Col>
              <Col xs={12} sm={6} md={6} lg={6} xl={6}>
                <div className="faq-list">
                  {
                    (page?.showcases[0]?.modules ? [...page?.showcases[0]?.modules] : [])
                      .sort((a, b) => a.sort ? a.sort - b.sort : a.id - b.id)
                      .map((item, index) => (
                        <div key={index} className="faq-item border-bottom">
                          <div
                            className=" fw500 f18 color7 faq-question d-flex justify-content-between align-items-center py-3"
                            onClick={() => toggleAccordion(index)}
                            style={{ cursor: "pointer" }}
                          >
                            <span>{t(item.title[lang])}</span>
                            {activeIndex === index ? <FaMinus /> : <FaPlus />}
                          </div>
                          {activeIndex === index && (
                            <div className="f14 fw400 color4 faq-answer pb-3 text-muted">
                              {item.sort === 1 || !item?.description[lang] ? <ChargingCalculator /> : item?.description[lang]}
                            </div>
                          )}
                        </div>
                      ))
                  }
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </Celikler> : <div className="modern-spinner-wrapper">
      <div className="modern-spinner"></div>
    </div>
  );
};

export default Sss;
